export default __webpack_public_path__ + "static/media/2logoiria.bd144537.jpg";